






































import { announcementController } from '@/api/Agency/agency.api'
import ActionButton from '@/components/ActionButton.vue'
import AnnouncementCrudDialog from '@/components/AnnouncementCrudDialog.vue'
import TableSwitch from '@/components/TableSwitch.vue'
import { tableComposition } from '@/compositions/table'
import { defineComponent } from '@vue/composition-api'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'
import TextButton from '~/components/TextButton.vue'

export default defineComponent({
  components: {
    ActionButton,
    AnnouncementCrudDialog,
    TableSwitch,
    FlatCard,
    FlatTable,
    TextButton,
  },
  setup: () => {
    return {
      ...tableComposition(announcementController),
    }
  },
  data() {
    return {
      headers: [
        { text: this.$t('title'), value: 'title' },
        { text: this.$t('start_date'), value: 'start_date' },
        { text: this.$t('end_date'), value: 'end_date' },
        { text: this.$t('agency_name'), value: 'agency_name' },
        { text: this.$t('is_active'), value: 'is_active' },
      ],
    }
  },
})
